import React, { useState } from 'react';
import { ActivityIndicator, View } from 'react-native';
import { useTheme } from '@/context/ThemeContext';
import Button from '@/components/Buttons/Button';
import Text from '@/components/Typography/Text';
import MediaImagePreview from './MediaImagePreview';
import { resolveFullSourceUri } from '@/constants/utils/media_preview';

function ImageLoad({ uri, file, style, onRetry }) {
  const { colors } = useTheme();
  const [loading, setLoading] = useState(!!uri);
  const [failed, setFailed] = useState(false);
  const [attempt, setAttempt] = useState(0);
  return <View style={style}>
    {failed || !uri ? (
      <View style={{ flex: 1, alignItems: 'center', justifyContent: 'center', gap: 12 }}>
        <Text accessibilityRole="alert">Could not load image</Text>
        {uri && <Button text="Retry image" accessibilityLabel="Retry image" onPress={event => {
          event?.stopPropagation?.();
          setFailed(false);
          setLoading(true);
          setAttempt(value => value + 1);
          onRetry?.();
        }} />}
      </View>
    ) : (
      <MediaImagePreview key={attempt} uri={uri} file={file} lazy={false}
        style={{ width: '100%', height: '100%' }} contentFit="contain"
        placeholder={file?.blurhash ? { blurhash: file.blurhash } : undefined} transition={200}
        onLoadStart={() => setLoading(true)} onLoadEnd={() => setLoading(false)}
        onError={() => { setFailed(true); setLoading(false); }} />
    )}
    {loading && !failed && <View style={{ pointerEvents: 'none', position: 'absolute', inset: 0, alignItems: 'center', justifyContent: 'center' }}>
      <ActivityIndicator accessibilityLabel="Loading image" color={colors.text_color_primary} />
    </View>}
  </View>;
}

export default function LightboxImagePreview({ uri, file, style, onRetry }) {
  const source = resolveFullSourceUri(uri, file);
  return <ImageLoad key={JSON.stringify([source, file?.thumbnailPath])} uri={source} file={file} style={style} onRetry={onRetry} />;
}
